export function incompleteSwitch(x: never): never {
  throw new Error(
    "Incomplete switch statement: make sure to cover all possible cases on your switch statement."
  );
}
